var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-input',{attrs:{"rules":_vm.rules,"label":_vm.label,"label-horizontal":_vm.labelHorizontal},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var uuid = ref.uuid;
return [_c('b-switch',_vm._g(_vm._b({attrs:{"id":uuid}},'b-switch',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }